import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule, Routes } from '@angular/router';
import { IsUserAuthorized } from '../services/authguard';
import { LoggedUserComponent } from './loggeduser.component';



const appRoutes: Routes = [
  {
    path: '',
    component: LoggedUserComponent,
    children: [

      {
        path: 'dashboard', loadComponent: () => import('../modules/dashboard/dashboard.component').then(m => m.DashboardComponent),
        canActivate: [IsUserAuthorized],
        pathMatch: 'prefix',
      },
      {
        path: 'informazioni', loadComponent: () => import('../modules/informazionipersonali/informazioni-personali.component').then(m => m.InformazioniPersonaliComponent),
        canActivate: [IsUserAuthorized],
        pathMatch: 'prefix'
      },
      {
        path: 'awards', loadComponent: () => import('../modules/awards/awards.component').then(m => m.AwardsComponent),
        canActivate: [IsUserAuthorized],
        pathMatch: 'prefix'
      },
      {
        path: 'rewards', loadComponent: () => import('../modules/rewards/rewards.component').then(m => m.RewardsComponent),
        canActivate: [IsUserAuthorized],
        pathMatch: 'prefix'
      },
      {
        path: 'payments', loadChildren: () => import('../modules/payments/payments.module').then(m => m.PaymentsModule),
        canActivate: [IsUserAuthorized],
        pathMatch: 'prefix'
      },
      {
        path: 'report', loadComponent: () => import('../modules/report/report.component').then(m => m.ReportComponent),
        canActivate: [IsUserAuthorized],
        pathMatch: 'prefix'
      },
      {
        path: 'subscriptions', loadComponent: () => import('../modules/subscriptions/subscriptions.component').then(m => m.SubscriptionsComponent),
        canActivate: [IsUserAuthorized],
        pathMatch: 'prefix'
      },
      {
        path: 'privacy', loadComponent: () => import('../modules/privacy/privacy.component').then(m => m.PrivacyComponent),
        canActivate: [IsUserAuthorized],
        pathMatch: 'prefix'
      },
      {
        path: '',
        redirectTo: 'dashboard',
        pathMatch: 'full'
      },

    ],

  },

];


@NgModule({
  declarations: [],
  imports: [
    RouterModule.forChild(appRoutes),
  ],
  exports:[RouterModule]
})
export class LoggedUserRoutesModule { }
